// test2572
(2572 && 0);
